import { render, staticRenderFns } from "./changePassPop.vue?vue&type=template&id=3445a638&scoped=true"
import script from "./changePassPop.vue?vue&type=script&lang=js"
export * from "./changePassPop.vue?vue&type=script&lang=js"
import style0 from "./changePassPop.vue?vue&type=style&index=0&id=3445a638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3445a638",
  null
  
)

export default component.exports